import { get, post } from "../common/helpers/http";

const WhiteLabelService = () => {
  function loginUser(email: string, password: string, proxy: string) {
    const proxy_config =
      proxy.length > 2
        ? {
            custom_proxy_id: proxy,
          }
        : {
            "location.countryISO": {
              $eq: proxy,
            },
            "provider.name": {
              $eq: "nord",
            },
          };
    return post("login", {
      email,
      password,
      proxy_config,
    }).then((resp) => resp.response);
  }

  function resendVerificationEmail(email: string) {
    return post(`login/${email}/resend`).then((resp) => resp.response);
  }

  function resolveLoginPin(email: string, pin: string) {
    return post(`login/${email}/resolve`, {
      pin,
    }).then((resp) => resp.response);
  }

  function resolvePhoneChallenge(
    email: string,
    countryCode: string,
    phoneNumber: string
  ) {
    return post(`login/${email}/phone`, {
      country_code: countryCode,
      phone_number: phoneNumber,
    }).then((resp) => resp.response);
  }

  function fetchLoginChallenge(email: string) {
    return get(`login/${email}/challenge`).then((resp) => resp.response);
  }

  function getCustomerCustomizations() {
    return get("customizations/customer").then((resp) => resp.customization);
  }

  function getAvailableProxies() {
    return get("login/proxies").then((resp) => resp.response);
  }

  function getAccount(accountId: string) {
    return get(`account/${accountId}`).then((resp) => resp.account);
  }

  function getReportData() {
    return get("report").then((resp) => resp);
  }

  return {
    loginUser,
    resendVerificationEmail,
    resolveLoginPin,
    resolvePhoneChallenge,
    fetchLoginChallenge,
    getCustomerCustomizations,
    getAvailableProxies,
    getAccount,
    getReportData,
  };
};

export default WhiteLabelService;
